import React from "react";

import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

const GREY = "#D8D8D8";
const useStyles = makeStyles(() => ({
  listRootDense: {
    padding: 0,
    "&:not(:last-child)": { borderBottom: `1px solid ${GREY}` }
  },
  listRootSpace: {
    border: `1px solid ${GREY}`,
    borderRadius: 4,
    marginBottom: 10,
    padding: 0
  },
  listItemTextPrimary: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center"
  },
  listItemTextPrimaryUser: { fontWeight: "bold" },
  listItemTextPrimaryRole: {
    fontStyle: "normal",
    fontSize: 11,
    color: GREY
  },
  listItemTextPrimaryText: {
    // enforce new lines
    whiteSpace: "pre-wrap"
  }
}));

const MessageList = ({ comment, space = false }) => {
  const {
    role,
    user_name,
    user_photo_url,
    created_at_formatted,
    role_formatted,
    message
  } = comment;
  const classes = useStyles();

  return (
    <List
      classes={{
        root: space ? classes.listRootSpace : classes.listRootDense
      }}
    >
      <ListItem secondaryAction={role}>
        <ListItemAvatar>
          <Avatar>
            <Avatar alt={user_name} src={user_photo_url} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <div className={classes.listItemTextPrimary}>
              <span className={classes.listItemTextPrimaryUser}>
                {user_name}
              </span>
              <span className={classes.listItemTextPrimaryRole}>
                {role_formatted}
              </span>
            </div>
          }
          secondary={`${created_at_formatted}`}
        />
      </ListItem>
      {message && message.length && (
        <ListItem>
          <ListItemText
            primary={
              <span className={classes.listItemTextPrimaryText}>{message}</span>
            }
          />
        </ListItem>
      )}
    </List>
  );
};

export default MessageList;
